import { render } from "./CardBrandSelectorLabel.vue?vue&type=template&id=699cd38e&lang=pug"
import script from "./CardBrandSelectorLabel.vue?vue&type=script&lang=js"
export * from "./CardBrandSelectorLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__